import Vue from 'vue'

Vue.filter('processText', function (text, details) {
  if (!text) return ''

  text = text.toString()

  text = text.replace(/{{name}}/gi, details.firstName)
  text = text.replace(/{{age}}/gi, getAgeString(details.birthDate))

  if (details.gender === 'male') {
    text = text.replace(/{{gender-he}}/gi, 'he')
    text = text.replace(/{{gender-his}}/gi, 'his')
    text = text.replace(/{{gender-him}}/gi, 'him')
  } else if (details.gender === 'female') {
    text = text.replace(/{{gender-he}}/gi, 'she')
    text = text.replace(/{{gender-his}}/gi, 'her')
    text = text.replace(/{{gender-him}}/gi, 'her')
  } else {
    text = text.replace(/{{gender-he}}/gi, 'he/she')
    text = text.replace(/{{gender-his}}/gi, 'his/her')
    text = text.replace(/{{gender-him}}/gi, 'him/her')
  }

  return text
})

function getAgeString (birthDate) {
  let duration = Math.floor(Date.now() / 1000.0) - Number(birthDate)
  var final = ''

  //
  // Get years
  //

  var yearSeconds = 365 * 24 * 60 * 60
  var monthSeconds = 30 * 24 * 60 * 60

  var years = Math.floor(duration / yearSeconds)

  duration = duration - (years * yearSeconds)

  var months = Math.floor(duration / monthSeconds)

  if (years > 0) {
    final += `${years.toString()} `
  }

  if (years > 1) {
    final += 'years'
  } else if (years === 1) {
    final += 'year'
  }

  //
  // Months
  //

  if (months > 0 && final !== '') {
    final += ' and '
  }

  if (months > 0) {
    final += `${months.toString()} `
  }

  if (months > 1) {
    final += 'months'
  } else if (months === 1) {
    final += 'month'
  }

  if (final === '') {
    final = '1 month'
  }

  return final
}
